import {memo, useEffect, useRef, useState} from 'react'
import NeedLogin from '../components/NeedLogin'
import {delay, useEffectAsync} from '../utils/common'
import {API_URL, getAccessToken, tempSaveAccessToken, WSAPI_URL} from '../utils/userApi'
import XIF from '../components/utils/XIF'
import {Modal} from '@arco-design/web-react'
import {IconRefresh} from '@arco-design/web-react/icon'

const VssPage = memo(({isEn}) => {

  const [userInfo, setUserInfo] = useState(null)
  const [vssUrl, setVssUrl] = useState('')
  const theWs = useRef(null)
  const [tryCount, setTryCount] = useState(0)
  const [connOk, setConnOk] = useState(false)
  const [stableOk, setStableOk] = useState(false)

  const query = new URLSearchParams(window.location.search)
  const area = query.get('area')
  const isUk = area === 'uk'

  useEffect(() => {
    setVssUrl(`https://${userInfo?.user?.uid}.cochiper.${isUk ? 'ai' : 'com'}`)
  }, [isUk, userInfo])

  useEffectAsync(async () => {
    await tempSaveAccessToken()
  }, [vssUrl])

  useEffect(() => {
    if (tryCount > 3) return
    theWs.current = new WebSocket(`${WSAPI_URL}/icrd/robbing-the-toilet?access_token=${getAccessToken()}`) // 替换为实际的 WebSocket URL
    theWs.current.onopen = async () => {
      setConnOk(true)
      theWs.current.nodie = true
      await delay(3000)
      setStableOk(true)
    }
    theWs.current.onmessage = (event) => {
    }
    theWs.current.onclose = () => {
      setConnOk(false)
      console.log('WebSocket Disconnected')
    }
    theWs.current.onerror = async (error) => {
      setConnOk(false)
      console.error('WebSocket Error', error)
      await delay(1000)
      setTryCount(prev => prev + 1)
    }
    return () => {
      theWs.current.close()
    }
  }, [tryCount])

  return <NeedLogin setUserInfo={setUserInfo}>
    <XIF condition={connOk}>
      <div className="w-[100vw] h-[100vh]">
        <iframe
          title="vss-win"
          src={vssUrl}
          width="100%"
          height="100%"
          allowFullScreen
          sandbox="allow-forms allow-same-origin allow-scripts"
        />
      </div>
    </XIF>
    <XIF condition={theWs && !connOk && stableOk}>
      <Modal
        title="当前页面已经过期"
        visible={true}
        okText={<><IconRefresh/> 刷新页面</>}
        onOk={() => {
          window.location.reload()
        }}
        focusLock={true}
      >
        <p>若要继续在此使用，可尝试刷新页面。</p>
      </Modal>
    </XIF>
  </NeedLogin>

})

export default VssPage
